import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  loadIrrigationAdvice,
  loadIrrigationAdviceFailure,
  loadIrrigationAdviceSuccess,
} from '../_actions/irrigationAdvice';
import { XapiIrrigationService } from '../_services';

@Injectable({
  providedIn: 'root',
})
export class IrrigationAdviceEffects {
  loadIrrigationAdvice$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadIrrigationAdvice),
      mergeMap(({ irrigationSupplyGetParams }) =>
        this.xapiIrrigationService.getIrrigationAdvice(irrigationSupplyGetParams).pipe(
          map((response) =>
            loadIrrigationAdviceSuccess({
              commodities: response.commodities,
              calculationEnabled: response.calculationEnabled,
            })
          ),
          catchError((error) => of(loadIrrigationAdviceFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private xapiIrrigationService: XapiIrrigationService
  ) {}
}
